"use client";

import { useTranslations } from "next-intl";
import { type HTMLAttributes, useState } from "react";
import { Pill } from "@/components/pill";
import { Button } from "@/components/ui/button";
import { ScrollArea, ScrollBar } from "@/components/ui/scroll-area";
import type { Globals } from "@/features/globals/types/globals.type";
import { cn } from "@/lib/utils";
import type { CateringCatalog } from "../types/catering-catalog.type";
import { CateringDietList } from "./catering-diet-list";
import { CateringDietLisetDrawer } from "./catering-diet-list-drawer";
import { CateringDietListExpandButton } from "./catering-diet-list-expand-button";

type CateringShowDietsProps = HTMLAttributes<HTMLDivElement> & {
  catering: CateringCatalog;
  globals?: Globals | null;
};

export const CateringDietListSmall = ({
  catering,
  globals,
  className,
  ...props
}: CateringShowDietsProps) => {
  const t = useTranslations("caterings");
  const [isDietListVisible, setIsDietListVisible] = useState(false);

  return (
    <div
      className={cn(
        "rounded-b-lg border border-brand-grey2 border-t-0 px-4 pb-3 md:py-3",
        className,
      )}
      {...props}
    >
      <header className="hidden items-center gap-2 md:flex">
        <span className="hidden md:block">{t("amount_of_diets")}:</span>
        <Pill variant="violet" className="hidden rounded-sm md:block">
          {catering.dietsCount}
        </Pill>

        <Button
          variant="secondary"
          size="sm"
          className="ml-auto gap-2"
          onClick={() => setIsDietListVisible(!isDietListVisible)}
        >
          <CateringDietListExpandButton visible={isDietListVisible} />
        </Button>
      </header>
      {isDietListVisible && (
        <ScrollArea>
          <CateringDietList catering={catering} globals={globals} />
          <ScrollBar orientation="horizontal" />
        </ScrollArea>
      )}
    </div>
  );
};
